/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Body_send_notifications_to_user_search_notification_user_notifications_post = {
    properties: {
        title: {
            type: 'TranslationBase',
            isRequired: true,
        },
        body: {
            type: 'TranslationBase',
            isRequired: true,
        },
        data: {
            type: 'dictionary',
            contains: {
                properties: {
                },
            },
            isRequired: true,
        },
    },
} as const;
